/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../docsAndForms/sections/docs-and-forms.form-builder.section.ts" />

module Meevo.Plugins.ClientIntakeForm {

    import BuilderEnum = Meevo.Plugins.DocsAndForms.BuilderEnum;

    class ClientIntakeFormController extends Meevo.Components.CommonClasses.CommonControllerBase {
        static $inject = [
            'meevo.AppSettings',
            'meevo.plugins.clientIntakeForm.ClientIntakeFormService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$translate',
            '$timeout',
            '$q',
            'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
            '$sce',
            'meevo.plugins.interop.InteropService',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
            'meevo.components.common.DataService',
            'meevo.plugins.docsAndForms.SystemTagsFactory',
        ];

        get isSelectedFormBuilderSection() {
            return this.context && this.context.selectedSection instanceof ClientIntakeFormMainSection;
        }

        get isFormBuilderOpened() {
            return this.isSelectedFormBuilderSection && (<ClientIntakeFormMainSection>this.context.selectedSection).selectedBuilder !== BuilderEnum.None;
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected clientIntakeFormService: ClientIntakeFormService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $q: ng.IQService,
            protected docsAndFormsRenderService: Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService,
            protected $sce: ng.ISCEService,
            protected interopService: Meevo.Plugins.Interop.InteropService,
            protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
            protected _dataService: Meevo.Components.BaseClasses.IDataService,
            protected _systemTagsService: Meevo.Plugins.DocsAndForms.SystemTagsFactory,
        ) {
            super(appSettings, clientIntakeFormService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this._systemTagsService.prepareClientIntakeFormSystemTags();
            this.createContext();
        }

        public createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_DOCSANDFORMS).then(() => {
                this.busyService.stop();
                this.context = new ClientIntakeFormContext(
                    this.appSettings,
                    this.clientIntakeFormService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService,
                    this.$translate,
                    this.docsAndFormsRenderService,
                    this.$sce,
                    this.$scope,
                    this.docsAndFormsService,
                    this._dataService,
                    this._systemTagsService
                );
                super.createContext();
            });
        }
    }

    angular.module('meevo.plugins.clientIntakeForm')
        .controller('meevo.plugins.clientIntakeForm.ClientIntakeFormController', ClientIntakeFormController);
}
